module.exports = __webpack_public_path__ + "img/api-access.22da614a.svg";